import { verificationsApi } from '../../../data/verificationsApi';
import type { VerificationView } from './verificationDetailViews';

/**
 * detail feature endpoints, injected into the single verifications base api.
 *
 * `getVerificationById` loads the full editable verification case by id (spec 004 identity + spec 005
 * Coverage sections); the case and its Encounter share the same id (`company-center-visitKey`), so
 * the page fetches both directly by the route id (research.md R-1). `saveVerification` persists the
 * whole `VerificationView` (`POST /Verification`) — the full view round-trips so non-Coverage
 * sections are never wiped (spec 005). The module verification slice hydrates from the read's
 * `matchFulfilled` and re-baselines on the save's `matchFulfilled`.
 */
export const verificationDetailEndpoints = verificationsApi.injectEndpoints({
  endpoints: (builder) => ({
    getVerificationById: builder.query<VerificationView, { id: string }>({
      query: ({ id }) => ({
        url: '/verification',
        method: 'GET',
        params: { id },
      }),
      providesTags: (_result, _error, { id }) => [{ type: 'Verification', id }],
    }),

    saveVerification: builder.mutation<VerificationView, VerificationView>({
      query: (body) => ({
        url: '/Verification',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, body) => [
        { type: 'Verification', id: body.id },
        'Worklist',
        'DashboardCounts',
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetVerificationByIdQuery, useSaveVerificationMutation } =
  verificationDetailEndpoints;
